import { useContext, useEffect } from 'react';

import ProtectedRoute from '@components/ProtectedRoute';
import Loader from '@components/Loader';

import SignUp from '@layouts/SignUp';
import Dashboard from '@layouts/Dashboard';
import Compare from '@layouts/Compare';
import Login from '@layouts/Login';
import LoginCallback from '@layouts/LoginCallback';
import LogoutCallback from '@layouts/LogoutCallback';
import UnderConstruction from '@layouts/UnderConstruction';
import LabourForecast from '@layouts/LabourForecast';

import { LoadingContext } from '@providers/Loading';

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

const App = () => {
    const { isLoading } = useContext(LoadingContext);
    const isUnderConstruction = (process.env.REACT_APP_UNDER_CONSTRUCTION && process.env.REACT_APP_UNDER_CONSTRUCTION.toLowerCase() === "true") || false;

    useEffect(() => {
        // Set the document title from the environment variable
        document.title = process.env.REACT_APP_TITLE || '';
    }, []);

    return (
        <div>
            <Loader active={isLoading} />
            <BrowserRouter>
                <Routes>
                    {isUnderConstruction ?
                        <>
                            <Route index element={<UnderConstruction />} />

                            <Route path="*" element={<Navigate to="/" replace />} />
                        </>
                        :
                        <>
                            <Route index element={<Login />} />
                            <Route path="/signUp" element={<SignUp />} />
                            <Route path="/dashboard" element={<ProtectedRoute element={Dashboard} />} />
                            <Route path="/compare" element={<ProtectedRoute element={Compare} />} />
                            <Route path="/loginCallback" element={<LoginCallback />} />
                            <Route path="/logoutCallback" element={<ProtectedRoute element={LogoutCallback} />} />
                            {process.env.REACT_APP_LABOUR_FORECAST_ENABLED === "true" &&
                                <Route path="/labourForecast" element={<ProtectedRoute element={() => <LabourForecast />} />} />}

                            <Route path="*" element={<Navigate to="/" replace />} />
                        </>
                    }
                </Routes>
            </BrowserRouter>
        </div>
    );
};

export default App;
